import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, WysiwygField, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { SCREEN_NORMAL } from '../../../config/constants';

import './style.scss';

export interface WebformApplicationRequestProps {
  id: string;
  children: React.ReactNode;
}

const ELEMENT_SCROLL_CUTOFF = 350;
const MAX_HEIGHT_SCROLL_CUTOFF_BOTTOM = 1100;
const ELEMENT_SCROLL_CUTOFF_BOTTOM = 370;

const WebformApplicationRequest: React.FC<WebformApplicationRequestProps> = ({ id, children }) => {
  const { width } = useWindowDimensions();
  const title = useSelector<ImmutableRootState<string>, string>((state) => (
    state.getIn(['webform', id, 'info', 'title'], '')
  ));
  const description = useSelector<ImmutableRootState<string>, string>((state) => (
    state.getIn(['webform', id, 'info', 'description'])
  ));

  // Set the calculator tool fixed when scrolling on desktop.
  useEffect(() => {
    const handleScroll = () => {
      const scrollElement = document.querySelector('.submit-container .webform-container .webform-container');
      if (scrollElement) {
        // Check if scrolled behind cutoff.
        if (window.scrollY > ELEMENT_SCROLL_CUTOFF && width > SCREEN_NORMAL) {
          scrollElement.classList.remove('scroll-container-bottom');
          scrollElement.classList.add('scroll-container');
        } else {
          scrollElement.classList.remove('scroll-container');
          scrollElement.classList.remove('scroll-container-bottom');
        }
        // Check if we reached the bottom cutoff and are below the max scroll screen height.
        if ((window.innerHeight + window.scrollY) >= (
          document.body.scrollHeight - ELEMENT_SCROLL_CUTOFF_BOTTOM
        ) && window.innerHeight < MAX_HEIGHT_SCROLL_CUTOFF_BOTTOM) {
          scrollElement.classList.remove('scroll-container');
          scrollElement.classList.add('scroll-container-bottom');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [width]);

  return (
    <div className="WebformApplicationRequest">
      <div className="WebformApplicationRequest__hero">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="WebformApplicationRequest__hero__title">
                <h4>{title}</h4>
              </div>
              <div className="WebformApplicationRequest__hero__subtitle">
                <WysiwygField
                  property="schema:text"
                  html={description}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Container>
        {children}
      </Container>
    </div>
  );
};

export default WebformApplicationRequest;
